import { accordionItemBuilder, Box, Text } from '@wix/design-system';
import React, { useCallback, useMemo } from 'react';
import { GroupExpansionStyle } from '../../types';
import { useOnToggleFunctions } from '../../utils/use-on-toggle-functions';
import { RulesList } from '../rules-list/rules-list';
import { GroupSuffix } from './group-suffix';
export const useCollapsibleGroup = _ref => {
  let {
    ruleGroups,
    parentNodeRef,
    selectedItemHeaderRef,
    selectedItemContentRef
  } = _ref;
  const initiallyOpenedGroup = useMemo(() => ruleGroups.find(ruleGroup => ruleGroup.expansionMode === GroupExpansionStyle.collapsible && ruleGroup.initiallyOpen), [ruleGroups]);
  const {
    onGroupToggle,
    selectedGroup,
    isGroupOpen
  } = useOnToggleFunctions();
  return useCallback(ruleGroupOrigin => {
    const {
      groupId,
      ruleResults,
      ruleGroupContent,
      disabled = false,
      isLoading = false,
      isFailed = false,
      isFetchResultsFailed = false,
      ruleResultsSkeletonComponent
    } = ruleGroupOrigin;
    const {
      groupLabel,
      subtitles: groupSubtitles
    } = ruleGroupContent;
    const isOpen = isGroupOpen(ruleGroupOrigin, initiallyOpenedGroup);
    return accordionItemBuilder({
      children: isLoading || isFetchResultsFailed ? ruleResultsSkeletonComponent : isFailed ? null : /*#__PURE__*/React.createElement("div", {
        ref: (selectedGroup == null ? void 0 : selectedGroup.groupId) === groupId ? selectedItemContentRef : null
      }, /*#__PURE__*/React.createElement(Box, {
        direction: "vertical"
      }, ruleGroupContent.rulesListHeader, /*#__PURE__*/React.createElement(RulesList, {
        parentNodeRef: parentNodeRef,
        ruleResults: ruleResults
      }))),
      disabled,
      key: groupId,
      onToggle: () => onGroupToggle(ruleGroups, groupId),
      open: isOpen,
      subtitle: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin"
      }, groupSubtitles),
      suffix: /*#__PURE__*/React.createElement(Box, {
        marginRight: "6px"
      }, /*#__PURE__*/React.createElement(GroupSuffix, {
        datahook: groupId,
        isOpen: isOpen,
        ruleGroupContent: ruleGroupContent
      })),
      title: /*#__PURE__*/React.createElement("div", {
        "data-hook": groupLabel,
        ref: (selectedGroup == null ? void 0 : selectedGroup.groupId) === groupId ? selectedItemHeaderRef : null,
        style: {
          wordBreak: 'break-word'
        }
      }, /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      }, groupLabel))
    });
  }, [initiallyOpenedGroup, isGroupOpen, onGroupToggle, parentNodeRef, ruleGroups, selectedGroup == null ? void 0 : selectedGroup.groupId, selectedItemContentRef, selectedItemHeaderRef]);
};
//# sourceMappingURL=use-get-collapsible-group.js.map